import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Typography,
  Grid
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(0, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(2, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

const Filter = props => {
  const { open, onClose,masters, onFilter, className, statusOptions, statusValue, ...rest } = props;

  const classes = useStyles();

  const initialValues = {
      name: '',
      company: '',
      mobile: '',
      city: '',
      version: null,
      commodity: [],
      ...(statusOptions ? { membership_status: 'all' } : {})
  };

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [values, setValues] = useState({ ...initialValues });

  useEffect(() => {
    if (!open || !statusOptions) {
      return;
    }
    setValues(current => ({
      ...current,
      membership_status: statusValue || 'all',
    }));
  }, [open, statusValue, statusOptions]);

  const handleClear = () => {
    setValues({ 
      ...initialValues });
  };

  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };
  const handleoptionchange = type => (event, value) => {
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  const handleinputchange = type => (e) => {
    setValues({
      ...values,
      [type]: e.target.value
    })
  }

  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };
  const handleDateChange = type => (date) => {
    setValues({
      ...values,
      [type]: date
    })
  };
  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
    
    onFilter && onFilter(values);
    onClose && onClose()
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant="temporary"
    >
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        <div className={classes.header}>
          <Button
            onClick={onClose}
            size="small"
          >
            <CloseIcon className={classes.buttonIcon} />
            Close
          </Button>
        </div>
        <div className={classes.content}>
          <Grid container xs={12} spacing={1}>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            value={values.name}
                            onChange={handleinputchange('name')}
                           label="Name"
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Mobile"
                           value={values.mobile}
                           onChange={handleinputchange('mobile')}
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="City"
                           value={values.city}
                           onChange={handleinputchange('city')}
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="District"
                           value={values.district}
                           onChange={handleinputchange('district')}
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="State"
                           value={values.state}
                           onChange={handleinputchange('state')}
                          />
            </Grid>
            <Grid xs={6}>
            <div className={classes.formGroup}>
                    <ToggleButtonGroup
                      exclusive
                      onChange={(event, value) =>
                        value && handleFieldChange(event, 'platform', value)
                      }
                      size="small"
                      value={values.platform}
                      variant="outlined"
                    >
                      <ToggleButton
                        color="primary"
                        value="android"
                      >
                        Android
                      </ToggleButton>
                      <ToggleButton value="ios">iOS</ToggleButton>
                    </ToggleButtonGroup>
                  </div>
            </Grid>
            {/* <Grid xs={12}>
            <Autocomplete
                  id="combo-box-demo"
                  options={masters.versions}
                  margin="dense"
                  fullWidth
                   value={values.version}
                  getOptionLabel={(option) => option.label}
                  onChange={handleoptionchange('version')}
                  renderInput={(params) => <TextField {...params} label={"Versions"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid>  */}
                      
            <Grid xs={6}>
            <div className={classes.formGroup}>
                    <ToggleButtonGroup
                      exclusive
                      onChange={(event, value) =>
                        value && handleFieldChange(event, 'isactive', value)
                      }
                      size="small"
                      value={values.isactive}
                      variant="outlined"
                    >
                      <ToggleButton
                        color="primary"
                        value="1"
                      >
                        Active
                      </ToggleButton>
                      <ToggleButton value="0">In Active</ToggleButton>
                    </ToggleButtonGroup>
                  </div>
            </Grid>
            <Grid item xs={12}>
            <Autocomplete
                
                  id="combo-box-demo"
                  options={masters?.usertypes || []}
                  margin="dense"
                  fullWidth
                  value={values.customertype || null}
                 onChange={handleoptionchange('customertype')}
                  getOptionLabel={(option) => option && option.name ? option.name : ''}
                  getOptionSelected={(option, value) => option && value && option.id === value.id}
                  renderInput={(params) => <TextField {...params} label={"Customer Types"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Company Name"
                           value={values.company}
                           onChange={handleinputchange('company')}
                          />
            </Grid>
          
            {statusOptions ? (
            <Grid item xs={12}>
              <TextField
                select
                variant="outlined"
                margin="dense"
                fullWidth
                label="Status"
                value={values.membership_status || 'all'}
                onChange={handleinputchange('membership_status')}
              >
                {statusOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            ) : null}
            <Grid item xs={12}>
            <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters.commodity}
                  margin="dense"
                  fullWidth
                  value={values.commodity}
                 onChange={handleoptionchange('commodity')}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={12}>
            <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters?.languages}
                  margin="dense"
                  fullWidth
                  value={values.language}
                 onChange={handleoptionchange('language')}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label={"Language"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item  container spacing={1}>
            <Grid item xs={6} >
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="DD/MM/YYYY"
                  maxDate={new Date()}
                  autoOk
                  inputVariant="outlined"
                  margin="dense"
                  id="date-picker-inline"
                  label="Member From"
                   value={values.memberfrom}
                   onChange={handleDateChange('memberfrom')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
      </Grid>
            <Grid item xs={6}>
                 <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="DD/MM/YYYY"
                  inputVariant="outlined"
                  margin="dense"
                  id="date-picker-inline"autoOk
                  label="Member To"
                  maxDate={new Date()}
                  value={values.memberto}
                   onChange={handleDateChange('memberto')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
        </Grid>
          </Grid>
          <Grid item  container spacing={1}>
            <Grid item xs={6}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="DD/MM/YYYY"
                  margin="dense"
                  id="date-picker-inline"
                  autoOk
                  label="Lastlogin From"
                  maxDate={new Date()}
                  value={values.lastloginfrom}
                   onChange={handleDateChange('lastloginfrom')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
      </Grid>
            <Grid item xs={6}>
                 <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="DD/MM/YYYY"
                  inputVariant="outlined"
                  autoOk
                  margin="dense"
                  id="date-picker-inline"
                  label="Lastlogin To"
                  maxDate={new Date()}
                  value={values.lastloginto}
                   onChange={handleDateChange('lastloginto')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
        </Grid>
          </Grid>
          </Grid>
        </div>
        <div className={classes.actions}>
          <Button
            fullWidth
            onClick={handleClear}
            variant="contained"
          >
            <DeleteIcon className={classes.buttonIcon} />
            Clear
          </Button>
          <Button
            color="primary"
            fullWidth
            type="submit"
            variant="contained"
          >
            Apply filters
          </Button>
        </div>
      </form>
    </Drawer>
  );
};

Filter.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  masters : PropTypes.object,
  open: PropTypes.bool.isRequired
};

export default Filter;
